import { PricingStoreState } from '@interfaces/PricingTypes'

const pricingState: PricingStoreState = {
  plansFeatures: {},
  prodConfig: {},
}

export default () => pricingState
